
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/product/courses-list",
      function () {
        return require("private-next-pages/product/courses-list/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/product/courses-list"])
      });
    }
  